import { Button, Dropdown, DropdownLink, Flex, For, IconFA, IntrinsicProps, Slot, createComponent } from 'react-commons';

import style from './index.module.scss';
import NavButtonLink from '@/components/NavButtonLink';
import PerDevice from '@/components/PerDevice';
import { useRouter } from 'next/router';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

export interface DailyHorizontalNavProps extends IntrinsicProps {
  preserveHorizontalMobile?: boolean
  isClassic?: boolean
  links: {
    href: string
    label: string
  }[]
}

const classStates = [
  'isClassic'
];

export default createComponent('DailyHorizontalNav', { style, classStates }, ({ className }, props: DailyHorizontalNavProps) => {

  const router = useRouter();

  const links = props.links.filter((link) => !!link.label);

  const selectedLink = links.find((link) => link.href === router.asPath);

  const horizontalMenu = (
    <Flex alignCenter justifyCenter className={className}>
      {
        For(links, (link, i) => (
          <NavButtonLink href={link.href} key={link.href}>
            {link.label}
          </NavButtonLink>
        ))
      }
    </Flex>
  );

  if(props.preserveHorizontalMobile) {
    return horizontalMenu;
  }

  return (
    <>
      <p id="linktop" className='LinkTop'></p>

      <PerDevice useDisplay>
        <Slot name='mobile'>
          <Flex justifyCenter>

            <Dropdown className={className}>
              <Slot name='trigger'>
                <Button rounded secondary small>
                  <span>{selectedLink?.label ?? ''}</span>
                  <IconFA icon={faChevronDown} />
                </Button>
              </Slot>

              <Slot name='content'>
                {
                  For(links, (link) => (
                    <DropdownLink href={link.href}>{link.label}</DropdownLink>
                  ))
                }
              </Slot>
            </Dropdown>
          </Flex>

        </Slot>
        <Slot name='desktop'>
          { horizontalMenu }
        </Slot>
      </PerDevice>
    </>
  );


});